// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "h2[data-v-3a0f5aa8] {\n  font-size: 18px;\n}\n.delete-title[data-v-3a0f5aa8] {\n  font-size: 1.875rem;\n  color: #003545;\n  word-break: keep-all;\n}\n.v-btn[data-v-3a0f5aa8] {\n  vertical-align: top;\n}\n.v-btn.v-btn--depressed[data-v-3a0f5aa8] {\n  min-width: 17% !important;\n}\n.notice[data-v-3a0f5aa8] {\n  background: #fffbe5;\n}\n.setup-pl[data-v-3a0f5aa8] {\n  color: #2d9cdb;\n}", ""]);
// Exports
module.exports = exports;
